import React from "react";
import { t } from "ttag";

import { ValuePropsBlock as Value } from "@reactivated";

import { Themed } from "../../styles/themes";
import { Carousel } from "../Carousel/Carousel";
import { Clickable } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

export const FALLBACK_LABEL = t`The SKS Experience`;

export const ValuePropsBlock = ({
    value: { theme, block_label, value_props },
}: {
    value: Value;
}) => {
    if (!value_props || value_props.length < 1) return <></>;

    return (
        <Themed
            theme={theme}
            className={styles.root}
            style={{ "--item-count": value_props.length }}
        >
            <Carousel
                label={block_label ?? FALLBACK_LABEL}
                containerProps={{ className: styles.carouselContainer }}
                scrollContainerProps={{ className: styles.list }}
                slideWrapperProps={{ className: styles.slideWrapper }}
                slideContainerProps={{ className: styles.listItem }}
                controls={({ allVisible }) => {
                    if (allVisible) return null;
                    return (
                        <div className={styles.controls}>
                            <Clickable
                                className={styles.arrowLeft}
                                slot="previous"
                            >
                                <Svg name="caret-right" />
                            </Clickable>
                            <Clickable
                                className={styles.arrowRight}
                                slot="next"
                            >
                                <Svg name="caret-right" />
                            </Clickable>
                        </div>
                    );
                }}
                dots={null}
            >
                {value_props.map((valueProp, index) => (
                    <div key={index}>{valueProp}</div>
                ))}
            </Carousel>
        </Themed>
    );
};
